export default {
  SET_STAGES(state, data) {
    state.stages = data
  },
  SET_STAGE_PLANNINGS(state, data) {
    state.stage_plannings = data
  },
}
